"use client";

import { useEffect, useRef, useState } from "react";
import { Button, SegmentedControl } from "@/app/components/ui";
import styles from "./EmbedPricingSection.module.css";

const QUOTA_ICONS = {
  video: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M19.5617 7C19.7904 5.69523 18.7863 4.5 17.4617 4.5H6.53788C5.21323 4.5 4.20922 5.69523 4.43784 7" />
      <path d="M17.4999 4.5C17.5283 4.24092 17.5425 4.11135 17.5427 4.00435C17.545 2.98072 16.7739 2.12064 15.7561 2.01142C15.6497 2 15.5194 2 15.2588 2H8.74099C8.48035 2 8.35002 2 8.24362 2.01142C7.22584 2.12064 6.45481 2.98072 6.45704 4.00434C6.45727 4.11135 6.47146 4.2409 6.49983 4.5" />
      <path d="M14.5812 13.6159C15.1396 13.9621 15.1396 14.8582 14.5812 15.2044L11.2096 17.2945C10.6669 17.6309 10 17.1931 10 16.5003L10 12.32C10 11.6273 10.6669 11.1894 11.2096 11.5258L14.5812 13.6159Z" />
      <path d="M2.38351 13.793C1.93748 10.6294 1.71447 9.04765 2.66232 8.02383C3.61017 7 5.29758 7 8.67239 7H15.3276C18.7024 7 20.3898 7 21.3377 8.02383C22.2855 9.04765 22.0625 10.6294 21.6165 13.793L21.1935 16.793C20.8437 19.2739 20.6689 20.5143 19.7717 21.2572C18.8745 22 17.5512 22 14.9046 22H9.09536C6.44881 22 5.12553 22 4.22834 21.2572C3.33115 20.5143 3.15626 19.2739 2.80648 16.793L2.38351 13.793Z" />
    </svg>
  ),
  bandwidth: (
    <svg viewBox="0 0 36 36" fill="currentColor" aria-hidden="true">
      <path d="M26.54,20.82a.88.88,0,0,0-.88-.88H20.75l1.1-1.1A.88.88,0,0,0,20.6,17.6l-3.21,3.22L20.6,24a.88.88,0,1,0,1.25-1.24L20.76,21.7h4.9A.88.88,0,0,0,26.54,20.82Z" />
      <path d="M29.27,21.7a.88.88,0,1,0,0-1.76h-.58a.88.88,0,1,0,0,1.76Z" />
      <path d="M32.21,20h-.06a.85.85,0,0,0-.85.88.91.91,0,0,0,.91.88.88.88,0,1,0,0-1.76Z" />
      <path d="M32.59,11a.88.88,0,0,0-1.25,1.24l1.1,1.1H27.53a.88.88,0,1,0,0,1.76h4.9l-1.09,1.09a.88.88,0,0,0,1.25,1.24l3.21-3.22Z" />
      <path d="M24.5,15.07a.88.88,0,1,0,0-1.76h-.58a.88.88,0,1,0,0,1.76Z" />
      <path d="M21.9,14.27a.85.85,0,0,0-.85-.88H21a.88.88,0,1,0,0,1.76A.91.91,0,0,0,21.9,14.27Z" />
      <path d="M30.36,23.65c0,.13,0,.26,0,.39a3.77,3.77,0,0,1-3.62,3.89H7.28a5.32,5.32,0,0,1-5.13-5.48A5.32,5.32,0,0,1,7.28,17H8.91L9,16.12a8.92,8.92,0,0,1,8.62-8h.08a8.49,8.49,0,0,1,6.56,3.29h2.37a10.55,10.55,0,0,0-8.91-5.25h-.11A10.82,10.82,0,0,0,7.22,15a7.28,7.28,0,0,0-7,7.43,7.27,7.27,0,0,0,7.08,7.43H26.77A5.72,5.72,0,0,0,32.35,24a3.77,3.77,0,0,0,0-.39Z" />
    </svg>
  ),
  users: (
    <svg viewBox="0 0 1024 1024" fill="currentColor" aria-hidden="true">
      <path d="M824.2 699.9a301.55 301.55 0 0 0-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 0 1 612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 0 0 8-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 0 1 612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z" />
    </svg>
  ),
};

const PLANS = [
  {
    id: "starter",
    name: "Starter",
    monthlyPrice: 19,
    yearlyMonthlyPrice: 15,
    description: "Drop the branding and get the full player toolkit.",
    quotas: [
      { label: "3 hosted videos", icon: "video" },
      { label: "250 GB bandwidth/mo", icon: "bandwidth" },
      { label: "1 team member", icon: "users" },
    ],
    features: [
      "Advanced analytics",
      "Full customization",
      // "All player themes",
      "Chapters & subtitles",
      "Web based video editor",
    ],
    cta: "Start free trial",
    ctaHref: "/register?plan=embed-starter",
    ctaVariant: "secondary",
  },
  {
    id: "pro",
    name: "Pro",
    monthlyPrice: 59,
    yearlyMonthlyPrice: 47,
    description: "Unlock advanced analytics and A/B testing.",
    quotas: [
      { label: "15 hosted videos", icon: "video" },
      { label: "1 TB bandwidth/mo", icon: "bandwidth" },
      { label: "3 team members", icon: "users" },
    ],
    features: [
      { label: "Everything in Starter", isPlus: true },
      "Engagement optimization",
      "Heatmaps",
      "A/B testing",
    ],
    cta: "Start free trial",
    ctaHref: "/register?plan=embed-pro",
    ctaVariant: "primary",
    highlight: true,
  },
  {
    id: "ultra",
    name: "Ultra",
    monthlyPrice: 179,
    yearlyMonthlyPrice: 143,
    description: "Built for large scale and more control.",
    quotas: [
      { label: "50 hosted videos", icon: "video" },
      { label: "3 TB bandwidth/mo", icon: "bandwidth" },
      { label: "10+ team members", icon: "users" },
    ],
    features: [
      { label: "Everything in Pro", isPlus: true },
      "Domain whitelisting",
    ],
    cta: "Start free trial",
    ctaHref: "/register?plan=embed-ultra",
    ctaVariant: "secondary",
  },
];

function formatPrice(value) {
  if (value === 0) return "0";
  return String(Math.round(value));
}

export default function EmbedPricingSection() {
  const [isYearly, setIsYearly] = useState(false);
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add(styles.visible);
        });
      },
      { threshold: 0.15 }
    );
    cardsRef.current.forEach((el) => {
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <section id="pricing" className={styles.pricing}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>7-day free trial on all paid plans</h2>
          <p className={styles.subtitle}>
            Start free. Upgrade when you need a custom player, real analytics, or scale.
          </p>
        </div>

        <div className={styles.billingToggleWrapper}>
          <SegmentedControl
            className={styles.billingToggle}
            fitContent
            size="lg"
            aria-label="Billing interval"
            value={isYearly ? "yearly" : "monthly"}
            onChange={(value) => setIsYearly(value === "yearly")}
            options={[
              { label: "Monthly", value: "monthly" },
              { label: "Yearly", value: "yearly" },
            ]}
          />
        </div>

        <div className={styles.planGrid}>
          {PLANS.map((plan, index) => {
            const effective = isYearly ? plan.yearlyMonthlyPrice : plan.monthlyPrice;
            const isHighlight = Boolean(plan.highlight);

            return (
              <div
                key={plan.id}
                ref={(el) => (cardsRef.current[index] = el)}
                className={`${styles.planCard} ${isHighlight ? styles.highlighted : ""}`}
                style={{ transitionDelay: `${index * 70}ms` }}
              >
                <div className={styles.planNameRow}>
                  <h3 className={styles.planName}>{plan.name}</h3>
                </div>

                <div className={styles.priceBlock}>
                  <div className={styles.currentPrice}>
                    <span className={styles.currency}>$</span>
                    <span className={styles.price}>{formatPrice(effective)}</span>
                    <span className={styles.period}>/mo</span>
                  </div>
                  {isYearly && plan.monthlyPrice > 0 && (
                    <p className={styles.periodNote}>
                      Billed ${formatPrice(effective * 12)}/year
                    </p>
                  )}
                  {isYearly && plan.monthlyPrice === 0 && (
                    <p className={`${styles.periodNote} ${styles.periodNotePlaceholder}`} aria-hidden="true">&nbsp;</p>
                  )}
                </div>

                <p className={styles.planDescription}>{plan.description}</p>

                <ul className={`${styles.featureList} ${styles.quotaList}`}>
                  {plan.quotas.map((quota) => (
                    <li key={quota.label} className={styles.featureItem}>
                      <span className={`${styles.featureCheck} ${styles.quotaIcon}`}>
                        {QUOTA_ICONS[quota.icon]}
                      </span>
                      <span>{quota.label}</span>
                    </li>
                  ))}
                </ul>

                <div className={styles.divider} />

                <ul className={styles.featureList}>
                  {plan.features.map((feature) => {
                    const label = typeof feature === "string" ? feature : feature.label;
                    const isPlus = typeof feature !== "string" && feature.isPlus;
                    return (
                      <li key={label} className={styles.featureItem}>
                        {isPlus ? (
                          <svg
                            className={`${styles.featureCheck} ${styles.featurePlus}`}
                            viewBox="0 0 16 16"
                            aria-hidden="true"
                          >
                            <path
                              d="M8 3.5v9M3.5 8h9"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2.25"
                              strokeLinecap="round"
                            />
                          </svg>
                        ) : (
                          <svg
                            className={styles.featureCheck}
                            viewBox="0 0 16 16"
                            aria-hidden="true"
                          >
                            <path
                              d="M3.5 8.5l3 3 6-6"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2.25"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        )}
                        <span>{label}</span>
                      </li>
                    );
                  })}
                </ul>

                <Button
                  variant={plan.ctaVariant === "primary" ? "attention" : "secondary"}
                  size="lg"
                  fullWidth
                  href={plan.ctaHref}
                >
                  {plan.cta}
                </Button>
              </div>
            );
          })}
        </div>

        <p className={styles.trialNote}>
          Paid plans include a 7-day free trial. Cancel anytime.
        </p>
      </div>
    </section>
  );
}
